import script from "./LicensePlateKeyboard.vue?vue&type=script&setup=true&lang=js"
export * from "./LicensePlateKeyboard.vue?vue&type=script&setup=true&lang=js"

import "./LicensePlateKeyboard.vue?vue&type=style&index=0&id=0e75d692&lang=scss&scoped=true"

import exportComponent from "D:\\wwwroot\\mld\\vue-source\\mileIsland\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e75d692"]])

export default __exports__